export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.8.7-0958.25",
  commitId: "12fa71d36e7016ad91c8b682f8314f5a029e3d33",
  commitTime: "2026-08-07T09:58:25.000Z",
});
